import { PaymentButton as Button } from '#src/components/DynamicComponents';
import { PageErrorComponent } from '#src/components/PageError';
import { ProductTermsAndConditionsStandardLabel as Label } from '#src/components/SummaryList/Summary/TermsAndConditionsStandardLabel';
import { withShoppingBasketContext } from '#src/withShoppingBasketContext';

export const PaymentButton = withShoppingBasketContext(Button);
export const ProductTermsAndConditionsStandardLabel =
  withShoppingBasketContext(Label);

export const PageError = withShoppingBasketContext(PageErrorComponent);
